import { Navigate, Route, Routes } from 'react-router-dom'
import { AuthProvider, useAuth } from './auth'
import { ToastProvider } from './components/Toast'
import { LoginPage } from './pages/LoginPage'
import { HomePage } from './pages/HomePage'
import { PluginHost } from './pages/PluginHost'
import { AdminUsersPage } from './pages/AdminUsersPage'
import { AdminFeaturesPage } from './pages/AdminFeaturesPage'
import { AdminAuditPage } from './pages/AdminAuditPage'

function Protected({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth()
  if (loading) return <div className="page-loading">Loading…</div>
  if (!user) return <Navigate to="/login" replace />
  return <>{children}</>
}

function OwnerOnly({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth()
  if (loading) return <div className="page-loading">Loading…</div>
  if (!user) return <Navigate to="/login" replace />
  if (!user.isOwner) return <Navigate to="/" replace />
  return <>{children}</>
}

function Router() {
  const { user, loading } = useAuth()
  if (loading) return <div className="page-loading">Loading…</div>

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <LoginPage />} />
      <Route
        path="/"
        element={
          <Protected>
            <HomePage />
          </Protected>
        }
      />
      <Route
        path="/plugin/:pluginId/*"
        element={
          <Protected>
            <PluginHost />
          </Protected>
        }
      />
      <Route
        path="/admin/users"
        element={
          <OwnerOnly>
            <AdminUsersPage />
          </OwnerOnly>
        }
      />
      <Route
        path="/admin/features"
        element={
          <OwnerOnly>
            <AdminFeaturesPage />
          </OwnerOnly>
        }
      />
      <Route
        path="/admin/audit"
        element={
          <OwnerOnly>
            <AdminAuditPage />
          </OwnerOnly>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <Router />
      </ToastProvider>
    </AuthProvider>
  )
}
